import React from 'react';
import Q from './item.js';
import DocsMenu from '@/components/Documents/docs/DocsMenu';

const { items, itemMap } = Q;

const keys = Object.keys(itemMap);
for (const key of keys) {
  const its = itemMap[key];
  console.log('its: ', itemMap[key])
  for (const it of its) {
    it.url = `/documents/izayoi_message${it.url}`;
  }
}

export default function ({ children, router }) {
  const result = { groups: items, groupMap: itemMap };

  const path = router.currentRoute.path;

  const defaultSelectedKeys = [];
  const defaultOpenKeys = [];

  for (const key of keys) {
    const its = itemMap[key];
    for (const it of its) {
      // (it.url, path, it.url === path);
      if(it.url === path) {
        defaultSelectedKeys.push(it.key);
        defaultOpenKeys.push(key);
        break;
      }
    }
  }

  result.defaultSelectedKeys = defaultSelectedKeys;
  result.defaultOpenKeys = defaultOpenKeys;
  result.path = path;

  return (
    <div style={{
      backgroundColor: '#ffffff',
      margin: '16px',
      padding: '16px 16px 16px 0px',
      display: 'flex',
      flexDirection: 'row'
    }}>
      <div style={{
        borderRight: '1px solid #e8e8e8',
        marginRight: '16px',
        minHeight: '80vh'
      }} ><DocsMenu {...result} /></div>
      {children}
    </div>
  )
}